import { DashboardModule } from '@domain-group/suit-theme'

import useCampaignComparables from '@hooks/useCampaignComparables'

import GridView from '../Views/GridView'
import ListView from '../Views/ListView'

interface ComparablesProps {
  comparablesPayload: ReturnType <typeof useCampaignComparables>,
  gridView: boolean,
  title: string,
}

const Comparables = (props: ComparablesProps) => {
  const { comparablesPayload, gridView, title } = props

  const {
    canLoadMore,
    callbacks: {
      loadMore,
    },
    filteredCampaignComparables,
    filteredCampaignComparablesCount,
    loading,
  } = comparablesPayload

  const Component = gridView ? GridView : ListView

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title={title}
    >
      <Component campaignComparables={filteredCampaignComparables} />

      <DashboardModule.LoadMoreFooter
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredCampaignComparablesCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default Comparables
